<div class="flex flex-justify-between flex-middle cursor-pointer _item"
     [class]="top() ? 'm-t-2 p-t-2-m p-t-1-s p-b-1 p-b-2-m p-b-1-s' : 'p-t-2 p-t-3-m p-t-3-s p-b-2 p-b-3-m p-b-3-s p-l-4-m p-l-4-s b-t b-col-5'"
     role="button"
     tabindex="0"
     (click)="productViewLayout().openSidebar('reviews')"
     (keypress)="productViewLayout().openSidebar('reviews')">
    <div class="flex flex-middle"
         [class.col-12]="top()">
        <rating class="flex flex-middle flex-justify-end"
                [value]="rating() / 20" />
        <p [class]="top() ? 's2' : 's1'">
            {{count()}} {{(count() === 1 ? 'review' : 'reviews') | translate}}
        </p>
    </div>
    @if (!top()) {
    <i class="m-r-1 m-r-3-m m-r-3-s icon-plus-24"
       aria-hidden="true"></i>
    }
</div>